import { VariableType } from 'json-to-graphql-query';
import type { FieldValue } from './types';

interface PermissionFieldResult {
  name: FieldValue;
  slug: FieldValue;
  granted: FieldValue;
}

interface ItemPermsQueryResult {
  query: {
    __variables: {
      globalId: 'ID!';
      parentCollectionId: 'ID';
    };
    itemPermissions: {
      __args: {
        globalId: VariableType;
        parentCollectionId: VariableType;
      };
      mediaPermissions: PermissionFieldResult;
      userPerms: PermissionFieldResult;
    };
  };
}

interface MyPermsQueryResult {
  query: {
    myPermissions: {
      userPerms: PermissionFieldResult;
    };
  };
}

export const itemPermsQ = (truify: boolean = false): ItemPermsQueryResult => ({
  query: {
    __variables: {
      globalId: 'ID!',
      parentCollectionId: 'ID',
    },
    itemPermissions: {
      __args: {
        globalId: new VariableType('globalId'),
        parentCollectionId: new VariableType('parentCollectionId'),
      },
      mediaPermissions: {
        name: truify,
        slug: truify,
        granted: truify,
      },
      userPerms: {
        name: truify,
        slug: truify,
        granted: truify,
      },
    },
  },
});

export const myPerms = (truify: boolean = false): MyPermsQueryResult => ({
  query: {
    myPermissions: {
      userPerms: {
        name: truify,
        slug: truify,
        granted: truify,
      },
    },
  },
});
